import TripAnnotation from "../../model/TripAnnotation";
import { getStartOfDayFrom } from "../trip/tripHelper";
import { hashToArray, isEmpty } from "../vanilla";

export function getTripAnnotationsForPastTwoDaysAndModifiedEntities(tripAnnotations: IIdDictionary<IIdDictionary<TripAnnotation>>) {
    let twoDaysAgo = getStartOfDayFrom(2);

    let filteredTripAnnotations: IIdDictionary<IIdDictionary<TripAnnotation>> = {};

    Object.keys(tripAnnotations).forEach(deviceId => {
        let deviceAnnotations = tripAnnotations[deviceId];
        let filteredDeviceAnnotations = {};
        if (deviceAnnotations && !isEmpty(deviceAnnotations)) {
            hashToArray(deviceAnnotations).forEach((annotation: TripAnnotation) => {
                if (typeof annotation.dateTime !== "undefined" && (annotation.dateTime >= twoDaysAgo.toISOString() || annotation.modified)) {
                    filteredDeviceAnnotations[annotation.id] = annotation;
                }
            });
        }
        filteredTripAnnotations[deviceId] = filteredDeviceAnnotations;
    });

    return filteredTripAnnotations;
}